/* Swap a video card's poster for the real player when it is pressed.

   Eight testimonial videos on one page is eight players, and an embedded
   YouTube frame costs more than the rest of a landing page put together. So
   each card ships as a still image with the player held in a <template>, and
   nothing is parsed or fetched until someone actually asks to watch.

   Pressing a second card stops the first: two videos talking over each other
   is nobody's idea of a testimonial. */
(function () {
  'use strict';

  var open = null;

  function close(frame) {
    if (!frame) return;
    var media = frame.querySelector('.wp-vt__media');
    if (media) media.remove();
    var button = frame.querySelector('.wp-vt__play');
    if (button) button.hidden = false;
  }

  function play(button) {
    var frame = button.closest('.wp-vt__frame');
    var template = frame && frame.querySelector('[data-wp-vt-source]');
    if (!frame || !template) return;

    if (open && open !== frame) close(open);

    frame.appendChild(template.content.cloneNode(true));
    button.hidden = true;
    open = frame;

    // An uploaded video needs telling to start; an iframe autoplays from its
    // own src. play() rejects when the browser blocks unmuted autoplay, which
    // is fine - the controls are right there.
    var video = frame.querySelector('video.wp-vt__media');
    if (video && typeof video.play === 'function') {
      var started = video.play();
      if (started && typeof started.catch === 'function') started.catch(function () {});
    }
  }

  function init(root) {
    (root || document).querySelectorAll('[data-wp-vt-play]').forEach(function (button) {
      if (button.dataset.wpVtReady) return;
      button.dataset.wpVtReady = '1';
      button.addEventListener('click', function () { play(button); });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  // The theme editor rebuilds a section's markup in place, which also means any
  // player that was open has gone with it.
  document.addEventListener('shopify:section:load', function (e) {
    open = null;
    init(e.target);
  });
})();
